
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useRef, useState } from 'react';
import Link from "next/link";
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from "embla-carousel-react";
import Counter from "../../../common/counter";
import { DotButton, useDotButton } from "./DotButton";
import classNames from "classnames";
const Banner = ({ t }) => {
    const banner = t('home:banner', {}, { returnObjects: true });
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 5000, stopOnInteraction: true })]);
    // const [emblaRef, emblaApi] = useEmblaCarousel({loop: true}, [])
    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const playerRef = useRef(null);
    const [player, setPlayer] = useState(null);
    useEffect(() => {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);
        window.onYouTubeIframeAPIReady = () => {
            const ytPlayer = new window.YT.Player(playerRef.current, {
                height: 'auto',
                width: '100%',
                videoId: '8adYLDGgbMQ',
                events: {
                    onReady: () => {
                        setPlayer(ytPlayer);
                    }
                }
            });
        };
        return () => {
            delete window.onYouTubeIframeAPIReady;
        };
    }, []);
    const stop = () => player?.stopVideo();
    return (<section className={'banner'}>
        <div className="container">

            <div className="embla">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">

                        <div className="banner_wrapper embla__slide">
                            <div className="banner_title">
                                <p className={'banner_title_top green'}>{banner.title_phone.top_title}</p>
                                <h1 className={'banner_title_title phones'}>
                                    <span>{banner.title_phone.title_1}</span>
                                    <span>{banner.title_phone.title_2}</span>
                                    <span>{banner.title_phone.title_3}</span>
                                </h1>
                                <h2 className={'banner_title_sub'}>{banner.title_phone.sub_title}</h2>
                                <div className={'banner_title_buy'}>
                                    <Link className={'main_button'} href={process.env.NEXT_PUBLIC_APP_URL}>
                                        {banner.title_phone.buy_btn}
                                    </Link>
                                    <div className={'presale'}>
                                        <h3>{banner.title_phone.presale_title}</h3>
                                        <picture>
                                            <source srcSet={`/img/pages/home/banner/presale_ccy.webp`} type="image/webp"/>
                                            <source srcSet={`/img/pages/home/banner/presale_ccy.png`}/>
                                            <img src={`/img/pages/home/banner/presale_ccy.png`} alt={`ColdWare Presale`} width={277} height={28} className='slider_icon_img'/>
                                        </picture>
                                    </div>
                                </div>
                            </div>
                            <div className="banner_phones">
                                <picture>
                                    <source media="(max-width: 768px)" srcSet={`/img/pages/home/banner/slider_phones_small.webp?v=2`} type="image/webp"/>
                                    <source media="(min-width: 769px)" srcSet={`/img/pages/home/banner/slider_phones.webp?v=2`} type="image/webp"/>
                                    <source media="(max-width: 768px)" srcSet={`/img/pages/home/banner/slider_phones_small.png?v=2`}/>
                                    <source media="(min-width: 769px)" srcSet={`/img/pages/home/banner/slider_phones.png?v=2`}/>
                                    <img src={`/img/pages/home/banner/slider_phones.png?v=2`} alt={`Larna 2400`} width={1322} height={1446} className='banner_phones_img'/>
                                </picture>
                            </div>
                        </div>

                        <div className="embla__slide" key={'larna'}>
                            <div className="embla__slide__number slide_wrapper counter larna">
                                <picture>
                                    <source srcSet={`/img/pages/home/banner/larna_banner.webp?v=4`} type="image/webp"/>
                                    <source srcSet={`/img/pages/home/banner/larna_banner.png?v=4`}/>
                                    <img src={`/img/pages/home/banner/larna_banner.png?v=2`} alt={`ColdWare Larna 2400 pre-order`} width={911} height={1276} className='banner_larna_img'/>
                                </picture>
                                <h2 className={'team_reveal_title'}>Larna 2400<br /> Web3 Mobile</h2>
                                <p className={'counter_title'}>Pre-Order NOW</p>
                                <p className={'counter_price'}>For $349</p>


                                <div className={'banner_title_buy'}>
                                    <Link className={'main_button'} href={process.env.NEXT_PUBLIC_APP_URL}>
                                        {banner.larna_cta}
                                    </Link>
                                    <div className={'presale'}>
                                        <h3>{banner.title.presale_title}</h3>
                                        <picture>
                                            <source srcSet={`/img/pages/home/banner/presale_ccy_fill.webp`} type="image/webp"/>
                                            <source srcSet={`/img/pages/home/banner/presale_ccy_fill.png`}/>
                                            <img src={`/img/pages/home/banner/presale_ccy_fill.png`} alt={`ColdWare Presale`} width={277} height={28} className='slider_icon_img'/>
                                        </picture>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="embla__controls">
                    <div className="embla__dots">
                        {scrollSnaps.map((_, index) => (<DotButton key={index} onClick={() => onDotButtonClick(index)} className={'embla__dot'.concat(index === selectedIndex ? ' embla__dot--selected' : '')}/>))}
                    </div>
                </div>
                <div className={classNames({
            "video_popup": true,
            "open": isVideoOpen
        })}>
                    <div className={'video_popup_content'}>
                        <img onClick={() => {
            stop();
            setIsVideoOpen(false);
            document.body.style.overflow = 'auto';
        }} className={'close'} src={'/img/icons/close_w.svg'} alt={'close image'}/>
                        <div className="" ref={playerRef}/>
                    </div>
                </div>
            </div>
        </div>
    </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__197633595fa__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197633595fa__ as getStaticProps }
  